import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import VideoBienvenida from "@/components/VideoBienvenida";

// Pantalla dedicada del video de bienvenida: va DESPUÉS de /perfil y ANTES de la mesa.
// Al montarse, la mesa y su tour no existen todavía: nada se ve ni se carga por detrás.
// Cuando el video termina, se saltea o no carga, recién ahí se navega a la mesa.
export default function BienvenidaVideo() {
  const nav = useNavigate();
  const { refreshMe } = useAuth();
  const salir = async () => {
    try { if (refreshMe) await refreshMe(); } catch {}
    nav("/", { replace: true });
  };
  return (
    <div className="min-h-screen bg-negro" data-testid="bienvenida-video-pantalla">
      <VideoBienvenida onDone={salir} />
    </div>
  );
}
